<template>
    <section>
        <h1>Estado Cartera</h1>
    </section>
</template>
<script>
    export default {
        setup () {
            return {}
            }

        }
</script>
<style scoped>
</style>
